export default {
    left:  {
        minimumSize: 200,
        maximumSize: 400,
    },
    right: {
        minimumSize: 200,
        maximumSize: 400,
    },
};